// extracted by mini-css-extract-plugin
export var linkText = "_mj-0";